import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../apiservice/apis";

export const fetchAdjustmentRecord = createAsyncThunk(
  "adjustmentRecord/fetch",
  async (
    { selectedFilterType, selectedRecordType, filters },
    { rejectWithValue }
  ) => {
    try {
      let url = "/inventory/get-adjustment-record";
      if (selectedRecordType === "with item") {
        url = "/inventory/get-adjust-record-with-details";
      }
      if (selectedFilterType !== "All" && selectedFilterType !== "By User") {
        url = "/inventory/get-adjustment-details";
      }

      const payload = {
        selectedFilterType: selectedFilterType || null,
        // selectedRecordType: selectedRecordType || null,
        locationId:
          selectedFilterType === "By Location"
            ? filters.locationId || null
            : null,
        itemId:
          selectedFilterType === "By Item" ? filters.itemId || null : null,
        groupId:
          selectedFilterType === "By Group" ? filters.groupId || null : null,
        categoryId:
          selectedFilterType === "By Category"
            ? filters.categoryId || null
            : null,
        userId:
          selectedFilterType === "By User" ? filters.userId || null : null,
        fromDate: filters.fromDate || null,
        toDate: filters.toDate || null,
        customerId: null,
      };

      const res = await postData(url, payload);

      let mapped = [];
      if (
        selectedRecordType === "with item" &&
        (selectedFilterType === "All" || selectedFilterType === "By User")
      ) {
        mapped = res.data.map((adj) => ({
          id: adj.adjust_id,
          vch_no: adj.voucher_no,
          date: adj.created_date,
          createdBy: adj.full_name,
          details: adj.details || [],
          total: Number(adj.total_amount || 0).toFixed(2),
          status: adj.status,
        }));
      } else if (
        selectedFilterType !== "All" &&
        selectedFilterType !== "By User"
      ) {
        mapped = res.data.map((row) => ({
          id: row.adjust_id,
          vch_no: row.voucher_no,
          date: row.created_date,
          createdBy: row.full_name,
          item_name: row.item_name,
          item_rate: row.item_rate,
          adjust_qty: row.item_qty,
          retail_qty: row.retail_qty,
          total: Number(row.item_total || 0).toFixed(2),
          details: [],
          tatmeen_sent_status: row.tatmeen_sent_status,
          tatmeen_sscc_status: row.tatmeen_sscc_status,
          sscc_code: row.sscc_code,
          tatmeen_message_id: row.tatmeen_message_id,
          tatmeen_retry_count: row.tatmeen_retry_count,
          tatmeen_failure_reason: row.tatmeen_failure_reason,
          tatmeen_manual_action_required:
            row.tatmeen_manual_action_required,
          tatmeen_last_retry_at:
            row.tatmeen_last_retry_at
        }));
      } else {
        mapped = res.data.map((row) => ({
          id: row.adjust_id,
          vch_no: row.voucher_no,
          date: row.created_date,
          createdBy: row.full_name,
          total: Number(row.total_amount || 0).toFixed(2),
          details: [],
          tatmeen_sent_status: row.tatmeen_sent_status,
          tatmeen_sscc_status: row.tatmeen_sscc_status,
          sscc_code: row.sscc_code,
          tatmeen_message_id: row.tatmeen_message_id,
          tatmeen_retry_count: row.tatmeen_retry_count,
          tatmeen_failure_reason: row.tatmeen_failure_reason,
          tatmeen_manual_action_required:
            row.tatmeen_manual_action_required,
          tatmeen_last_retry_at:
            row.tatmeen_last_retry_at
        }));
      }

      return mapped;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const deleteAdjustment = createAsyncThunk(
  "adjustmentRecord/delete",
  async (adjust_id, { rejectWithValue }) => {
    try {
      const res = await postData("/inventory/adjustment-delete", { adjust_id });
      return { adjust_id, msg: res.data.message };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


export const retryAdjustmentDestroy =
  createAsyncThunk("adjustmentRecord/retryDestroy",
    async (adjustId, thunkAPI) => {
      try {
        const response = await postData(
          "/inventory/adjustment-destroy-retry",
          {
            adjust_id: adjustId
          }
        );
        if (response?.error) {
          return thunkAPI.rejectWithValue(
            response.message ||
            "Retry failed"
          );
        }
        return response;
      }
      catch (error) {
        return thunkAPI.rejectWithValue(
          error?.response?.data?.error ||
          error.message ||
          "Retry failed"
        );
      }
    }
  );
